/* eslint-disable */
import '../../webparts/faq.scss';
import * as React from 'react';
import { useStore } from '../stores/root-store-context';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Button, Collapse, Descriptions, Flex, Modal, Select, Spin } from 'antd';
import { Typography } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import TextArea from 'antd/es/input/TextArea';
import { FAQItem, GetFAQsResponse } from '../api/FAQApi';
import { useDispatch } from "react-redux";
import Headers from "../../../../../redux/Actions/Headers/Header";

const { Title, Paragraph } = Typography;

export const FAQApp = observer(() => {
  const { applicationStore } = useStore();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isAuthorized, setIsAuthorized] = React.useState<boolean>(true);
  const [properties, setProperties] = React.useState<DefaultOptionType[]>([]);
  const [selectedProperty, setSelectedProperty] = React.useState<DefaultOptionType | null>(null);
  const [collapseItems, setCollapseItems] = React.useState<any[]>([]);
  const [collapseActiveKeys, setCollapseActiveKeys] = React.useState<any[]>([]);
  const [changedItems, setChangedItems] = React.useState<FAQItem[]>([]);
  const [isExpandAll, setIsExpandAll] = React.useState<boolean>(false);
  const [faqsResponce, setFaqsResponce] = React.useState<GetFAQsResponse>({ faqs: [], isWriteMode: false } as GetFAQsResponse);

  const showStickySave = faqsResponce.isWriteMode;
  const disableStickySave = changedItems.length === 0;

  const dispatch = useDispatch();

  const onChangeProperty = async (value: any, option: DefaultOptionType): Promise<void> => {
    setIsLoading(true);
    setSelectedProperty(option);
    const response = await applicationStore.getFAQs(option.value as string);
    setFaqsResponce(response);
    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(
      Headers.setHeader({
        title: "FAQ - Frequently Asked Questions",
        actions: [
          {
            type: "div",
            content: (
              <div className="faq__header-search">
                <Flex wrap="wrap" gap="small">
                  <Select
                    data-testid="faq-property-select"
                    style={{ width: "300px", maxWidth: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().indexOf(input.toLowerCase()) > -1
                    }
                    options={properties}
                    placeholder="Please select the property..."
                    onChange={onChangeProperty}
                    value={selectedProperty?.value}
                    dropdownStyle={{ maxWidth: '95vw' }}
                  />
                </Flex>
              </div>
            ),
          },
        ],
      })
    );
    return () => {
      dispatch(Headers.resetHeader());
    };
  }, [dispatch, properties, selectedProperty, onChangeProperty]);

  useEffect(() => {
    applicationStore.LoadPropertyListAsync()
      .then((response) => {
        setProperties(response.data.properties.map((i) => ({ value: i.id, label: `${i.name} (${i.id})` })));
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
        setIsAuthorized(false);
      });
  }, []);

  const changedQuestion = (question: FAQItem) => {
    setChangedItems(prevItems => {
      const existingQuestion = prevItems.find(q => q.QuestionId === question.QuestionId);
      if (existingQuestion) {
        return [...prevItems.map(q => q.QuestionId === question.QuestionId ? question : q)];
      } else {
        return [...prevItems, question];
      }
    });
  };

  const QuestionComponent = ({ question }: { question: FAQItem }) => {
    const [answer, setAnswer] = React.useState<string>(question.Answer);
    return (
      <div style={{ marginBottom: "14px" }} >
        <Title level={4} style={{ marginTop: "0px" }}>{question.Subject}</Title>
        <Paragraph underline>{question.Question}</Paragraph>
        <TextArea disabled={!faqsResponce.isWriteMode} value={answer} onChange={(e: any) => { changedQuestion({ ...question, Answer: e.target.value }); setAnswer(e.target.value); }} />
        {question.IsDefaultValue &&
          <div style={{ cursor: "pointer" }} onClick={() => {
            if (faqsResponce.isWriteMode) {
              changedQuestion(question);
              setAnswer(question.DefaultAnswer);
            }
          }}>
            <Descriptions style={{ marginTop: "14px" }}>
              <Descriptions.Item label="default">{question.DefaultAnswer}</Descriptions.Item>
            </Descriptions>
          </div>}
      </div>
    );
  }

  useEffect(() => {
    const newCollapseItems = faqsResponce.faqs.map((item: FAQItem[], index: number) => {
      return {
        key: index,
        label: item[0].Category,
        children: item.map((q, qIndex) => {
          return <QuestionComponent question={q} key={qIndex}></QuestionComponent>
        }),
      }
    })
    setCollapseItems(newCollapseItems);
  }, [faqsResponce]);


  const [isSaveConfirmVisible, setIsSaveConfirmVisible] = React.useState(false);

  const handleSaveConfirmed = async () => {
    setIsSaveConfirmVisible(false);
    setIsLoading(true);
    applicationStore.saveQuestions(changedItems).then(() => {
      setIsLoading(false);
      setChangedItems([]);
    }).catch(() => {
      setIsLoading(false);
    });
  };

  const onSave = () => {
    setIsSaveConfirmVisible(true);
  };


  if (!isAuthorized) {
    return <Title level={3}>We&apos;re sorry, your request is unauthorized.</Title>
  }

  return (
    <div>
      <Spin spinning={isLoading}>
        {collapseItems?.length == 0 ? (
          <div className="faq__empty-message">
            Please select a property using the selector in the top right corner.
          </div>
        ) : null}
        {collapseItems.length > 0 ? (
          <div className="faq__container">
            <div className="faq__actions-bar">                  
              {selectedProperty && (
                <div className="faq__property-name">
                  {selectedProperty.label}
                </div>
              )}
              <Button
                data-testid="faq-expand-collapse-btn"
                className="faq__expand-btn"
                type="primary"
                ghost
                onClick={() => {
                  setIsExpandAll(!isExpandAll);
                  setCollapseActiveKeys(isExpandAll ? [] : collapseItems.map(i => i.key));
                }}
              >
                {isExpandAll ? "Collapse All" : "Expand All"}
              </Button>
            </div>
            <Collapse onChange={(i) => Array.isArray(i) ? setCollapseActiveKeys(i as []) : setCollapseActiveKeys([i])} items={collapseItems} activeKey={collapseActiveKeys}></Collapse>
          </div>
        ) : null}
        {showStickySave && (
          <div className="faq__sticky-save">
            <Button
              data-testid="faq-save-btn"
              type="primary"
              size="large"
              onClick={onSave}
              style={{ width: 200 }}
              disabled={disableStickySave}
            >
              Save
            </Button>
          </div>
        )}
        <Modal
          data-testid="faq-save-confirm-modal"
          title="Confirm Save"
          open={isSaveConfirmVisible}
          onOk={handleSaveConfirmed}
          onCancel={() => setIsSaveConfirmVisible(false)}
          okText="Yes, Save"
          cancelText="Cancel"
        >
          <p>Are you sure you want to save these changes to the FAQ?</p>
        </Modal>
      </Spin>
    </div>
  );
});